<div id="m" class="page-layout-container">
  <div id="mobility" class="page-container card-root">
    <header class="header-section">
      <h1 class="title">Update Employees Monthly Mobility Allowance</h1>
      <p class="lead">
        Apply monthly allowances and review history for selected employees.
      </p>
    </header>

    <section class="top-controls">
      <div class="input-left">
        <label class="field-label">Search Employee</label>
        <app-emp-name
          [filterEmpName]="filterEmpName"
          (empName)="empNameSelected($event)"
        ></app-emp-name>
      </div>
      <div class="input-right">
        <label class="field-label">Select Month</label>
        <mat-form-field appearance="fill" class="month-picker">
          <input
            matInput
            [matDatepicker]="dp"
            (dateChange)="fetchMobilityDetails($event)"
            placeholder="Select Month"
            [formControl]="yearSelected"
          />
          <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
          <mat-datepicker
            #dp
            panelClass="example-month-picker"
          ></mat-datepicker>
        </mat-form-field>
      </div>
    </section>

    <section class="alerts">
      <div *ngIf="message" class="alert alert-success">{{ messageDesc }}</div>
      <div *ngIf="error" class="alert alert-danger">{{ errorDesc }}</div>
      <div *ngIf="warningDesc" class="alert alert-warning">
        {{ warningDesc }}
      </div>
    </section>

    <section class="card card-section">
      <form [formGroup]="mobilityForm" class="mobility-settings">
        <div class="left">
          <mat-checkbox
            formControlName="isMobilityOpted"
            (change)="enableMobilitySection($event.checked)"
            >Mobility Opted</mat-checkbox
          >
        </div>
        <div class="right" *ngIf="mobilitySecFlag">
          <mat-form-field appearance="fill">
            <mat-label>Mobility Start Date</mat-label>
            <input
              matInput
              [matDatepicker]="mobilityStartDate"
              [matDatepickerFilter]="dateFilter"
              formControlName="mobilityEffectiveDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="mobilityStartDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #mobilityStartDate></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Applicable Mobility Budget</mat-label>
            <input
              matInput
              placeholder="In Euros"
              formControlName="applicableBudget"
            />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Consumed Mobility Budget</mat-label>
            <input
              matInput
              placeholder="In Euros"
              formControlName="consumedBudget"
            />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Available Mobility Budget</mat-label>
            <input
              matInput
              placeholder="In Euros"
              formControlName="availableBudget"
            />
          </mat-form-field>
        </div>
      </form>
    </section>

    <div class="section-divider" *ngIf="mobilitySecFlag">
      Apply Monthly Mobility Allowance
    </div>

    <section class="card card-section" *ngIf="mobilitySecFlag">
      <form [formGroup]="monthMobilityForm" class="allowance-form">
        <div class="grid-row">
          <mat-form-field appearance="fill" class="grid-col">
            <mat-label>House Allowance</mat-label>
            <input
              matInput
              placeholder="In Euros"
              type="number"
              formControlName="compHouse"
              (change)="calculateTotalAllowance()"
            />
          </mat-form-field>

          <mat-form-field appearance="fill" class="grid-col">
            <mat-label>Travel Allowance</mat-label>
            <input
              matInput
              placeholder="In Euros"
              type="number"
              formControlName="compTravelPass"
              (change)="calculateTotalAllowance()"
            />
          </mat-form-field>

          <mat-form-field appearance="fill" class="grid-col">
            <mat-label>Other Allowance</mat-label>
            <input
              matInput
              placeholder="In Euros"
              type="number"
              formControlName="compOthers"
              (change)="calculateTotalAllowance()"
            />
          </mat-form-field>

          <mat-form-field appearance="fill" class="grid-col">
            <mat-label>Total Allowance</mat-label>
            <input
              matInput
              placeholder="In Euros"
              type="number"
              formControlName="totalAllowanceApplied"
              readonly
            />
          </mat-form-field>
        </div>

        <mat-form-field appearance="fill" class="comments-field">
          <mat-label>Comments</mat-label>
          <textarea matInput formControlName="comments" rows="2"></textarea>
        </mat-form-field>

        <div class="actions">
          <button
            mat-raised-button
            color="primary"
            [disabled]="!monthMobilityForm.valid || !mobilityForm.valid"
            (click)="onSubmit()"
          >
            Submit
          </button>
        </div>
      </form>
    </section>

    <div class="section-divider" *ngIf="applieMobilityMonths.length > 0">
      Applied Mobility Allowance History
    </div>

    <section
      class="card card-section table-card"
      *ngIf="applieMobilityMonths.length > 0"
    >
      <mat-form-field appearance="standard" class="filter-field">
        <mat-label>Filter</mat-label>
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="search with employee id, name..."
          #input
        />
      </mat-form-field>

      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <ng-container matColumnDef="monthName" sticky>
            <th mat-header-cell *matHeaderCellDef>Month</th>
            <td mat-cell *matCellDef="let element">{{ element.monthName }}</td>
          </ng-container>

          <ng-container matColumnDef="compHouse" sticky>
            <th mat-header-cell *matHeaderCellDef>House</th>
            <td mat-cell *matCellDef="let element">{{ element.compHouse }}</td>
          </ng-container>

          <ng-container matColumnDef="compTravelPass">
            <th mat-header-cell *matHeaderCellDef>Travel</th>
            <td mat-cell *matCellDef="let element">
              {{ element.compTravelPass }}
            </td>
          </ng-container>

          <ng-container matColumnDef="compOthers">
            <th mat-header-cell *matHeaderCellDef>Others</th>
            <td mat-cell *matCellDef="let element">{{ element.compOthers }}</td>
          </ng-container>

          <ng-container matColumnDef="totalAllowanceApplied">
            <th mat-header-cell *matHeaderCellDef>Total</th>
            <td mat-cell *matCellDef="let element">
              {{ element.totalAllowanceApplied }}
            </td>
          </ng-container>

          <ng-container matColumnDef="comments">
            <th mat-header-cell *matHeaderCellDef>Comments</th>
            <td mat-cell *matCellDef="let element">{{ element.comments }}</td>
          </ng-container>

          <ng-container matColumnDef="uploadedBy">
            <th mat-header-cell *matHeaderCellDef>Applied By</th>
            <td mat-cell *matCellDef="let element">{{ element.updatedBy }}</td>
          </ng-container>

          <ng-container matColumnDef="updateDate">
            <th mat-header-cell *matHeaderCellDef>Applied Date</th>
            <td mat-cell *matCellDef="let element">
              {{ element.updateDate | date: "dd/MMMM/yyyy" }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>

      <mat-paginator
        [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons
      ></mat-paginator>
    </section>
  </div>
</div>
